import React from "react";
import { Col, Row } from "reactstrap";
import { formatDate } from "../../services/api.service.js";

/**
 * Read only summary of the selected outgoing invoice plus the dispatch rows it
 * covers. Shared by the Courier create and Courier view screens so both show
 * the operator exactly the same thing.
 *
 * `invoice` / `dispatches` come straight from POST /invoice/view.
 */
const CourierInvoiceDetails = ({ invoice, dispatches, showCourier = false }) => {
  if (!invoice) return null;

  return (
    <>
      <div className="mt-2 mb-3 p-3 border rounded bg-light">
        <h5 className="fw-bold mb-3">Invoice Details</h5>

        <Row>
          <Col md="4">
            <p>
              <strong>Outgoing Invoice No: </strong>
              {invoice?.invoice_number || "-"}
            </p>
            <p>
              <strong>Zone: </strong>
              {invoice?.zone?.zone_name || "-"}
            </p>
            <p>
              <strong>Branch: </strong>
              {invoice?.branch?.branch_name || "-"}
            </p>
          </Col>

          <Col md="4">
            <p>
              <strong>Status: </strong>
              {invoice?.status === 1
                ? "Courier Pending"
                : invoice?.status === 2
                  ? "Courier Completed"
                  : "-"}
            </p>
            <p>
              <strong>Outgoing Invoice Date: </strong>
              {invoice?.createdAt ? formatDate(invoice?.createdAt) : "-"}
            </p>
            <p>
              <strong>Invoiced By: </strong>
              {invoice?.created_user?.full_name || "-"}
            </p>
          </Col>

          {showCourier && invoice?.status === 2 && (
            <Col md="4">
              <p>
                <strong>Courier Name: </strong>
                {invoice?.courier_name || "-"}
              </p>
              <p>
                <strong>Courier Docket No: </strong>
                {invoice?.courier_docket_number || "-"}
              </p>
              <p>
                <strong>Courier Docket Date: </strong>
                {invoice?.courier_docket_date
                  ? formatDate(invoice?.courier_docket_date)
                  : "-"}
              </p>
            </Col>
          )}
        </Row>
      </div>

      <h5 className="fw-bold mb-2">Dispatch Details</h5>

      {dispatches?.length ? (
        dispatches.map((dispatch, index) => (
          <div
            key={dispatch?.id || index}
            className="mb-3 p-3 border rounded shadow-sm"
            style={{ fontSize: "13px" }}
          >
            <h6 className="fw-semibold border-bottom pb-2 mb-3 text-primary">
              {dispatch?.dispatched_no || "-"}
            </h6>

            <Row>
              <Col md="4">
                <p>
                  <strong>Dispatch Date: </strong>
                  {dispatch?.dispatch_date
                    ? formatDate(dispatch?.dispatch_date)
                    : "-"}
                </p>
                <p>
                  <strong>Intake No: </strong>
                  {dispatch?.intake?.intake_no || "-"}
                </p>
              </Col>

              <Col md="4">
                <p>
                  <strong>Item Description: </strong>
                  {dispatch?.intake?.material?.descriptions || "-"}
                </p>
                <p>
                  <strong>GMDS Code: </strong>
                  {dispatch?.intake?.material?.gmds_code ||
                    dispatch?.intake?.material?.name ||
                    "-"}
                </p>
              </Col>

              <Col md="4">
                <p>
                  <strong>Serial No: </strong>
                  {dispatch?.intake?.material_serial_no || "-"}
                </p>
                <p>
                  <strong>Job Card No: </strong>
                  {dispatch?.job_card?.job_card_no || "-"}
                </p>
              </Col>
            </Row>
          </div>
        ))
      ) : (
        <p className="text-muted">No dispatch details found for this invoice.</p>
      )}
    </>
  );
};

export default CourierInvoiceDetails;
